import ApiResource from 'resources/ApiResource'

interface User {
  role: string;
  id: string | number;
  name: string;
  preferred_language?: string | null;
}

interface Course {
  id: string | number;
  title: string;
  category: string;
  organization: string;
  organization_id: string | number;
}

interface Organization {
  id: string | number;
  slug: string;
  title: string;
}

export default class OrganizationSignupResource extends ApiResource {
  static urlRoot = '/onboarding/organizations' as const;

  readonly auth_token: string = '';
  readonly user: User = { role: '', id: '', name: '' };
  readonly courses: Course[] = [];
  readonly organization: Organization = { id: '', slug: '', title: '' };

  pk() {
    return this.auth_token?.toString();
  }
}
